export default {
    address: 'adresse',
    activity: 'activité',
    bill: 'facture fournisseur',
    calendar_event: 'événement de calendrier',
    campaign: 'campagne',
    campaign_template: 'modèle de campagne',
    contact: 'contact',
    contact_list: 'liste de contacts',
    contract: 'contrat',
    credit_note: 'note de crédit',
    customer: 'client',
    domain: 'domaine',
    equipment: 'équipement',
    expense: 'dépense',
    hosting_account: "compte d'hébergement",
    invoice: 'facture',
    journal_entry: 'écriture de journal',
    ledger_entry: 'écriture de grand livre',
    opportunity: 'opportunité',
    product: 'produit',
    project: 'projet',
    prospect: 'prospect',
    public_form: 'formulaire public',
    quote: 'soumission',
    recurring_schedule: 'récurrence',
    supplier: 'fournisseur',
    survey: 'enquête',
    task: 'tâche',
    ticket: 'billet',
    warehouse: 'entrepôt'
};
